export type ApiResponse<T> = {
  data: T | undefined;
  error: ApiError | undefined;
};

export interface ApiError {
  status: number;
  error?: string;
  description?: string;
  meta?: Map<string, string>;
}

export enum GENERIC_ERROR {
  UNAUTHORIZED = 'Unauthorized',
}
